import React from 'react';
import { useSelector } from 'react-redux';
import ProjectBusPriorityRow from './projectBusPriorityRow/index';

const ProjectBusPriorityList = () => {
    const projectBusPriorityList = useSelector(state => state.projectBusPrioritys.projectBusPriorityList);
    return (
        <div className="app-main-content">
            {projectBusPriorityList.map((entry, index) => <ProjectBusPriorityRow key={index} projectBusPriority={entry} /> )}
        </div>
    );
};

export default ProjectBusPriorityList;


// WEBPACK FOOTER //
// ./components/Agile/projectBusPriority/projectBusPriorityList/index.js